import { Tab } from '@/components/ui/tabs';
import { SearchPage } from '@/graphql/generated/graphql';
import { fetchSearchPage, fetchSearchPageable, SearchPageableResult } from '@/services/search/search.service';
import { useEffect, useState } from 'react';

export const ALL_NAME = 'ALL';
export const KNOWLEDGE_HUB_NAME = 'KNOWLEDGE_HUB';
export const PODCAST_NAME = 'PODCAST';
export const LEARN_NAME = 'LEARN';

export function useSearch() {
  const [resources, setResources] = useState<SearchPageableResult>({
    data: [],
    pagination: {
      page: 0,
      pageCount: 0,
    },
    hasMore: {
      resources: false,
      courses: false,
      podcasts: false,
    },
  });
  const [search, setSearch] = useState('');
  const [searchPage, setSearchPage] = useState<SearchPage | null>(null);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [firstTime, setfirstTime] = useState(true);
  const [tabs, setTabs] = useState<Tab[]>([
    {
      name: ALL_NAME,
      current: true,
    },
    {
      name: KNOWLEDGE_HUB_NAME,
      current: false,
    },
    {
      name: PODCAST_NAME,
      current: false,
    },
    {
      name: LEARN_NAME,
      current: false,
    },
  ]);

  const loadMoreData = async () => {
    try {
      setLoadingMore(true);
      const data = await fetchSearchPageable(resources?.pagination?.page + 1, {
        search: search,
      });

      setResources((prevResources) => {
        return {
          // eslint-disable-next-line no-unsafe-optional-chaining
          data: [...prevResources?.data, ...data?.data],
          pagination: data?.pagination,
          hasMore: data?.hasMore,
        };
      });
    } finally {
      setLoadingMore(false);
    }
  };

  const selectedTab = tabs.find((tab) => tab.current)!;
  const filteredData = resources?.data?.filter((item) => {
    if (selectedTab.name === ALL_NAME) {
      return true;
    }
    if (selectedTab.name === KNOWLEDGE_HUB_NAME) {
      return item.__typename === 'ResourceEntity';
    }
    if (selectedTab.name === PODCAST_NAME) {
      return item.__typename === 'PodcastEntity';
    }
    if (selectedTab.name === LEARN_NAME) {
      return item.__typename === 'CourseEntity';
    }

    return false;
  });

  const showMoreButton =
    selectedTab.name === ALL_NAME
      ? resources?.pagination?.page + 1 < resources?.pagination?.pageCount
      : resources?.hasMore[selectedTab.name];

  const fetchSearch = async (resetFilter: boolean = false) => {
    try {
      setfirstTime(false);
      setLoading(true);
      const data = await fetchSearchPageable(1, { search: resetFilter ? '' : search });
      setResources(data);
    } finally {
      setLoading(false);
    }
  };

  const fetchPage = async () => {
    const pageResult = await fetchSearchPage();
    setSearchPage(pageResult.page);
  };

  useEffect(() => {
    fetchPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    resources,
    search,
    setSearch,
    loading,
    firstTime,
    loadingMore,
    tabs,
    setTabs,
    filteredData,
    fetchSearch,
    loadMoreData,
    showMoreButton,
    searchPage,
  };
}
